import { css } from 'styled-components'
import { makeStyles } from '@material-ui/styles'
import { content } from '~/themes/colors'

export const iconButtonStyle = css`
	fill: transparent;
`
export const labelStyle = css`
	font-weight: 600;
	font-size: 12px;
	line-height: 18px;
	display: flex;
	align-items: center;
	letter-spacing: 0.1px;
	color: ${({ theme }) => theme.palette.primary.main};
	text-transform: capitalize;
`

export const useStyles = makeStyles((theme) => ({
	datePicker: {},
	label: {
		color: theme?.palette?.primary?.main,
		marginBottom: 4,
		...theme?.typography?.subtitle2,
	},
	inputRoot: {
		'& .MuiInputBase-input': {
			paddingBottom: '10px',
			color: content.veryDark,
			...theme.typography.body1,

			'&::placeholder': {
				color: content.dark,
				opacity: 1,
			},
		},
		'& .MuiIconButton-edgeEnd': {
			margin: 0,
			padding: 0,
		},
	},
	input: {},
}))
